import { FormSetting } from '@/form-settings/form-setting';

export class UtilizzatoreForm extends FormSetting {
  protected static classToCall: string = 'UtilizzatoreForm';

  public static getMeta(): Array<any> {
    return [
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'bpUtilizzatore',
            controlType: 'number',
            label: 'BP Utilizzatore',
            order: 1,
            class: 'md:w-6/12 lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'denominazioneUtilizzatore',
            controlType: 'textinput',
            label: 'Denominazione Utilizzatore',
            order: 2,
            class: 'md:w-6/12 lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'indirizzoUtilizzatore',
            controlType: 'textinput',
            label: 'Indirizzo Utilizzatore',
            order: 3,
            class: 'md:w-full lg:w-4/12 w-full',
          },
        ],
        order: 1,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'cittaUtilizzatore',
            controlType: 'textinput',
            label: 'Città Utilizzatore',
            order: 1,
            class: 'md:w-6/12 lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'patenteUtilizzatore',
            controlType: 'textinput',
            label: 'Patente Utilizzatore',
            order: 2,
            class: 'md:w-6/12 lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'patenteRilasciataDaUtilizzatore',
            controlType: 'textinput',
            label: 'Patente Rilasciata Da',
            order: 3,
            class: 'md:w-full lg:w-4/12 w-full',
          },
        ],
        order: 2,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'pivaUtilizzatore',
            controlType: 'textinput',
            label: 'P.IVA Utilizzatore',
            order: 1,
            class: 'md:w-6/12 lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'codiceFiscaleUtilizzatore',
            controlType: 'textinput',
            label: 'Codice Fiscale Utilizzatore',
            order: 2,
            class: 'md:w-6/12 lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'telefonoUtilizzatore',
            controlType: 'textinput',
            label: 'Telefono Utilizzatore',
            order: 3,
            class: 'md:w-full lg:w-4/12 w-full',
          },
          {
            classToUse: this.classToCall,
            key: 'emailUtilizzatore',
            controlType: 'textinput',
            label: 'Email Utilizzatore',
            order: 4,
            class: 'md:w-full lg:w-4/12 w-full',
          },
        ],
        order: 3,
      },
    ];
  }
}
